export default __webpack_public_path__ + "static/media/40_owls.6c6b07ec.JPG";